import { ThemedComponentWrapper } from '@blockanalitica/ui';
import { ThemedComponentWrapperProps } from '@blockanalitica/ui/package/types/src/theme/ThemedComponentWrapper';
import { Link, LinkProps } from 'react-router';

export interface LinkButtonProps extends Partial<ThemedComponentWrapperProps> {
  to: LinkProps['to'];
  variant?: string;
  size?: 'default' | 'small';
  target?: string;
}

export default function LinkButton({
  children,
  variant = 'primary',
  size = 'default',
  ...rest
}: LinkButtonProps) {
  return (
    <ThemedComponentWrapper
      name="linkButton"
      variant={variant}
      // @ts-ignore
      as={Link}
      padding={size === 'small' ? '2xs xs' : 'xs s'}
      {...rest}>
      {children}
    </ThemedComponentWrapper>
  );
}
